import React from 'react';

export const Other = ({ width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_29829_2181)">
      <path
        d="M0.199219 0.199234L6.95685 5.16167L13.733 0.24853L0.199219 0.199234Z"
        fill="#23B99A"
      />
      <path
        d="M0 0V10.4281H14V0H0ZM6.67752 5.20481L0.400528 9.83245V0.595657L6.67752 5.20481ZM7.01438 4.95423L0.811326 0.400528H13.1907L7.01438 4.95628V4.95423ZM6.42899 10.0296L10.4815 7.09448L10.2474 6.76995L5.74707 10.0296H0.809272L13.5995 0.595657V10.0276H6.42899V10.0296Z"
        fill="#221F1F"
      />
    </g>
    <defs>
      <clipPath id="clip0_29829_2181">
        <rect width="14" height="10.4281" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
